import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './ContentCollection.scss';
import ContentCard from 'Components/ContentCard';
import LoadMore from 'Components/LoadMore';
import GradeTitleText from './collection-header-grade-text.svg';
import GradeNumber from './collection-header-grade-number.svg';
import VideosHeader from './videos-header.svg';
import GamesHeader from './games-header.svg';
import BooksHeader from './reading-header.svg';
import MathHeader from './math-zone-list-header.svg';
import PreKHeader from './pre-k-header.svg';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';

class ContentCollection extends Component {
  constructor(props) {
    super(props);
    this.state = this.loadData(props);
    this.handleClick = this.handleClick.bind(this);
    this.setOffset = this.setOffset.bind(this);
  }

  loadData(props) {
    const items = props.items ? props.items : [];
    // console.log(props.listId);
    // console.log(items);
    // console.log(props.itemsPerPage);
    const initialShowLoadMore = items.length > props.itemsPerPage;

    return {
      showLoadMore: initialShowLoadMore && props.paginated,
      loadingMore: false,
      offset: 0,
      items: items.slice(0, props.itemsPerPage),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.listId !== this.props.listId) {
      this.setState(this.loadData(this.props.items));
    }
  }

  handleClick(e) {
    e.preventDefault();
    this.setState({ loadingMore: true }, () => this.setOffset());
  }

  setOffset() {
    const { itemsPerPage, items } = this.props;
    const offset = this.state.offset + itemsPerPage;
    const showLoadMore = offset + itemsPerPage < items.length;
    this.setState(
      {
        offset,
        showLoadMore,
      },
      () => this.fetchItems(offset + itemsPerPage, items)
    );
  }

  fetchItems(sliceEnd, items) {
    const newItems = items.slice(0, sliceEnd);
    this.setState({
      loadingMore: false,
      items: newItems,
    });
  }

  render() {
    const { title, displayType, params, location, type } = this.props;
    const { items, showLoadMore, loadingMore } = this.state;
    const mediaHeaderMap = {
      '/games': <GamesHeader />,
      '/videos': <VideosHeader />,
      '/books': <BooksHeader />,
      '/pre-k-and-k-playground': <PreKHeader />,
      '/math-zone': <MathHeader />,
    };

    let sortedItems = items;
    if (title === 'New Games') {
      sortedItems = sortedItems.sort((a, b) =>
        a.launchDate < b.launchDate ? 1 : -1
      );
    }
    if (title === 'New Books') {
      sortedItems = sortedItems.sort((a, b) =>
        a.dateAdded < b.dateAdded ? 1 : -1
      );
    }
    return (
      <div className="ContentCollection" data-display-type={displayType}>
        {title && displayType === 'module' && (
          <CollectionHeader {...this.props} />
        )}

        {params && params.grade && displayType === 'grid' && (
          <GradeHeader {...this.props} />
        )}

        {type.match(/^all_/) && displayType === 'grid' && (
          <header className="ContentCollection__header">
            {mediaHeaderMap[location.pathname]}
          </header>
        )}

        <div className="ContentCollection__items">
          {sortedItems.map((item, i) => (
            <ContentCard index={i} key={i} {...item} />
          ))}
        </div>

        {showLoadMore && (
          <LoadMore isLoading={loadingMore} onClick={this.handleClick} />
        )}
      </div>
    );
  }
}

ContentCollection.propTypes = {
  items: PropTypes.array.isRequired,
  itemsPerPage: PropTypes.number,
  displayType: PropTypes.string,
  paginated: PropTypes.bool,
};

ContentCollection.defaultProps = {
  displayType: 'grid',
  paginated: false,
};

const GradeHeader = () => {
  return (
    <header className="ContentCollection__header">
      <GradeTitleText className="ContentCollection__grade-text" />
      <GradeNumber className="ContentCollection__grade-number" />
    </header>
  );
};

export const CollectionHeader = ({ title, link }) => (
  <header className="ContentCollection__header">
    <h4 className="ContentCollection__title">{title}</h4>
    {link && (
      <Link to={link} className="ContentCollection__more-link">
        More like this
      </Link>
    )}
  </header>
);

export default withLocationWrapper(ContentCollection);
